import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolDiscordCockpitService } from '../../../services/patrol-discord-cockpit.service';

@Component({
  selector: 'app-patrol-discord-moderation-ledger',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './patrol-discord-moderation-ledger.component.html',
  styleUrl: './patrol-discord-moderation-ledger.component.scss',
})
export class PatrolDiscordModerationLedgerComponent {
  #cockpit = inject(PatrolDiscordCockpitService);

  readonly ledgerItems = this.#cockpit.ledgerItems;
  readonly isLoading = this.#cockpit.isLoadingLedger;
  readonly loadError = this.#cockpit.ledgerError;
  readonly nextBefore = this.#cockpit.ledgerNextBefore;
  readonly userFilter = this.#cockpit.ledgerUserFilter;

  formatDate(iso: string): string {
    return this.#cockpit.formatDate(iso);
  }

  shortCaseId(caseId: string): string {
    return caseId.slice(0, 8);
  }

  actionLabel(action: string): string {
    return `app.patrol.discord.cockpit.ledger.actions.${action}`;
  }

  onUserFilterChange(value: string): void {
    this.#cockpit.setLedgerUserFilter(value);
  }

  async applyFilter(): Promise<void> {
    await this.#cockpit.loadModerationLedger({
      discordUserId: this.userFilter(),
    });
  }

  async loadMore(): Promise<void> {
    await this.#cockpit.loadMoreModerationLedger();
  }

  openCase(caseId: string): void {
    this.#cockpit.openCaseRecord(caseId);
  }
}
